<template>
 <div> 
  <v-tooltip bottom v-model="showColorTooltip" v-if="data.column.field == 'color'">
    <template v-slot:activator="{ on, attrs }">
      <v-chip  v-on="on" v-bind="attrs" label class="color-chip" @dblclick="onColorDoubleClick" :color="colValue" dark small :data-color="colValue">
      </v-chip>
    </template>
    <span> {{  $t("admin.msgDoubleClickToEditColor") }} </span>
  </v-tooltip>
  <div v-else-if="data.column.type == 'boolean'">
    <v-tooltip bottom v-model="booleanTooltip" v-if="data.column.field == 'order' || data.column.field == 'is_displayed_on_annual_plan' || data.column.field == 'isapprovalrequired'">
      <template v-slot:activator="{ on, attrs }">
        <div  v-on="on" v-bind="attrs" @dblclick="onBooleanDoubleClick">
          <v-icon
            small
            color="green darken-2"
            v-if="colValue == 'true' || colValue == true"
          >
            mdi-check 
          </v-icon>
          <v-icon
            small
            color="red darken-2"
            v-else
          >
          mdi-close  
          </v-icon>
        </div>
      </template>
      <span> {{  $t("admin.msgDoubleClickToEditColumn", { column: data.column.field == "order" ? $t("admin.lblOrder") : (data.column.field == "is_displayed_on_annual_plan" ? $t("admin.lblDisplayedOnAnnualSummary") : $t("admin.lblApprovalRequired")) }) }} </span>
    </v-tooltip>
    <div v-else>
      <v-icon
      small
      color="green darken-2"
      v-if="colValue == 'true' || colValue == true"
    >
      mdi-check 
    </v-icon>
    <v-icon
      small
      color="red darken-2"
      v-else
    >
    mdi-close  
    </v-icon> 
    </div>
    
  </div>
  <div v-else>
    <v-tooltip bottom v-model="showColorTooltip" v-if="data.column.field == 'order'">
    <template v-slot:activator="{ on, attrs }">
      <span  v-on="on" v-bind="attrs" @dblclick="onColorDoubleClick">
        {{ colValue }}
      </span>
    </template>
    <span> {{  $t("admin.msgDoubleClickToEditColumn", { column: $t("admin.lblOrder") }) }} </span>
  </v-tooltip>
    <span v-else>{{ colValue }} </span>
  </div>
 </div>
</template>

<script>
import _ from "lodash";
import { DEFAULT_MEETING_TYPE_COLOR } from "../../utils/constant";
export default {
  name: "columnTemplate",
  data() {
      return {
        data: {},
        showColorTooltip: false,
        booleanTooltip: false
      };
    },
  computed:{
    colValue(){
      //const dataItem = _.cloneDeep(this.data)
      let field = this.data.column.field;
        if (this.data[field]) {
          const data = _.cloneDeep(this.data[field])
          if(typeof(data) !== 'object'){
            return this.data[field];
          }else{
            if(field == 'color'){
              return DEFAULT_MEETING_TYPE_COLOR;
            }
            return '';
          }
          
        } else {
          if(field == 'color'){
              return DEFAULT_MEETING_TYPE_COLOR;
          }
          if (this.data[field] == 0) {
            return this.data[field];
          }
          else if (field === 'is_displayed_on_annual_plan' && this.data[field] === undefined) {
            return 'true';
          } else return '';
        }
    }
  },
  methods: {
    onColorDoubleClick() {
      this.showColorTooltip = false;
    },
    onBooleanDoubleClick() {
      this.booleanTooltip = false;
    }
  }
};

</script>

<style>
.color-chip{
  width: 100px !important;
  border: 1px solid rgba(0, 0, 0, 0.3) !important;
}
</style>